import type { UnitPreference } from '../types';
import { cmToFeetInches, feetInchesToCm } from '../units';
import { Field } from './Field';

type HeightInputProps = {
  label: string;
  /** Always in cm. */
  value_cm: number | null;
  onChange: (next_cm: number | null) => void;
  unit: UnitPreference;
};

export function HeightInput({ label, value_cm, onChange, unit }: HeightInputProps) {
  if (unit === 'imperial') {
    const { feet, inches } = value_cm === null ? { feet: 0, inches: 0 } : cmToFeetInches(value_cm);
    return (
      <Field label={label}>
        <div className="row" style={{ gap: 8 }}>
          <input
            className="input"
            type="number"
            inputMode="numeric"
            min="0"
            max="9"
            placeholder="ft"
            value={value_cm === null ? '' : feet}
            onChange={(e) => {
              const f = e.target.value === '' ? 0 : Number(e.target.value);
              if (!Number.isFinite(f)) return;
              onChange(feetInchesToCm(f, value_cm === null ? 0 : Math.round(inches)));
            }}
          />
          <span className="muted">ft</span>
          <input
            className="input"
            type="number"
            inputMode="numeric"
            min="0"
            max="11"
            placeholder="in"
            value={value_cm === null ? '' : Math.round(inches)}
            onChange={(e) => {
              const i = e.target.value === '' ? 0 : Number(e.target.value);
              if (!Number.isFinite(i)) return;
              onChange(feetInchesToCm(value_cm === null ? 0 : feet, i));
            }}
          />
          <span className="muted">in</span>
        </div>
      </Field>
    );
  }

  return (
    <Field label={label}>
      <div className="unit-row">
        <input
          className="input"
          type="number"
          inputMode="numeric"
          step="1"
          min="0"
          placeholder="e.g. 178"
          value={value_cm ?? ''}
          onChange={(e) => {
            if (e.target.value === '') return onChange(null);
            const n = Number(e.target.value);
            if (!Number.isFinite(n)) return;
            onChange(+n.toFixed(0));
          }}
        />
        <div className="input input--small" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'default' }}>
          cm
        </div>
      </div>
    </Field>
  );
}
